import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationKO from './locales/ko/translation.json';
import translationEN from './locales/en/translation.json';

// Translation resources
const resources = {
    ko: {
        translation: translationKO
    },
    en: {
        translation: translationEN
    }
};

i18n
    // Detects user language
    .use(LanguageDetector)
    // Passes i18n instance to react-i18next
    .use(initReactI18next)
    // Initialize i18next
    .init({
        resources,
        fallbackLng: 'ko', // Default language if detection fails
        supportedLngs: ['ko', 'en'], // Supported languages

        // Language detection options
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'], // Cache language in localStorage
        },

        interpolation: {
            escapeValue: false // React already escapes values
        },

        debug: false // Set to true for debugging
    });

export default i18n;
